// AboutUs.js (Parent Component)
import React, { useCallback } from "react";
import "./aboutSection.css";
import Icons from "../../../../config/images";
import { useNavigate } from "react-router-dom";

const ImageSection = () => (
  <div className="image-section-section">
    <img src={Icons.phoneSimulator} alt="Software Development" />
  </div>
);

const CompanyInfo = () => (
  <div className="company-info-section">
    <h3 className="company-info-title-section">Who We Are</h3>
    <p className="company-info-sub-title-style-section">
      With a team of passionate developers, designers, and strategists, we
      specialize in creating transformative digital experiences. Whether it's a
      sleek mobile application, a high-performance website, or a user-friendly
      interface, we ensure every solution is designed to perfection.
    </p>
    <h3 className="company-info-expertise-title-section">Our Expertise</h3>
    <ul className="company-info-expertise-details-style-section">
      <li className="company-info-expertise-seperate-details-style-section">
        <p className="company-info-sub-title-black-text-style-section">
          Mobile App Development:
        </p>
        <p className="company-info-sub-title-style-section">
          {" "}
          iOS, Android, and cross-platform apps.
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style-section">
        <p className="company-info-sub-title-black-text-style-section">
          Web Development:
        </p>
        <p className="company-info-sub-title-style-section">
          {" "}
          Secure websites with modern technologies.
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style-section">
        <p className="company-info-sub-title-black-text-style-section">
          UI/UX Design:
        </p>
        <p className="company-info-sub-title-style-section">
          {" "}
          Intuitive and seamless experiences..
        </p>
      </li>
      <li className="company-info-expertise-seperate-details-style-section">
        <p className="company-info-sub-title-black-text-style-section">
          Full-Stack Development:
        </p>
        <p className="company-info-sub-title-style-section">
          Frontend-to-backend solutions.
        </p>
      </li>
    </ul>
  </div>
);

const AboutUs = () => {
  const navigate = useNavigate();
  const onBtnPress = useCallback(() => {
    navigate("/contact-form");
  }, [navigate]);

  return (
    <div className="about-us-main-container-----">
      <section className="about-us-container----">
        <div className="heading-container">
          <span className="green-line"></span>
          <h4 className="about-us-gray-text-style">About Us</h4>
        </div>
        <h2 className="section-heading-section">
          Top Software Development Company
        </h2>
        <p className="about-us-section-description">
          At BA Code Solution, where innovation meets precision, we are
          committed to delivering exceptional IT solutions that cater to the
          evolving demands of the digital world.
        </p>
        <div className="about-content-section">
          <CompanyInfo />
          <ImageSection />
        </div>
      </section>

      <div className="cta-button-main-div-about-section">
        <button className="cta-button-about-touch-section" onClick={onBtnPress}>
          Get In Touch
        </button>
      </div>
    </div>
  );
};

export default AboutUs;
